import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { type AppDispatch, type AppState } from "../../store";
import { getOfferRequests, deleteOfferRequest } from "./modules/actions";

const mapStateToProps = (state: AppState) => ({
  state: {
    offerRequests: state.offerRequestReducer.offerRequests,
    loggedUser: state.authReducer.loggedUser,
  },
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  actions: bindActionCreators(
    {
      getOfferRequests,
      deleteOfferRequest,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
